"use client";

import React, { useState, ReactNode } from "react";
import Button from "@components/atoms/Button";
import styles from "./ServiceCost.module.scss";

interface ServiceCostClientWrapperProps {
  children: ReactNode;
  fuelTypesAvailable: string[];
  showFilter: boolean;
}

export const ServiceCostClientWrapper = ({
  children,
  fuelTypesAvailable,
  showFilter,
}: ServiceCostClientWrapperProps) => {
  const [selectedFuel, setSelectedFuel] = useState<string>(
    fuelTypesAvailable[0] || "PETROL"
  );

  return (
    <div className={styles.serviceCostWrapper}>
      {showFilter && (
        <div className={styles.filterWrapper}>
          {fuelTypesAvailable.map((fuel) => (
            <Button
              size="ds"
              key={fuel}
              className={
                selectedFuel === fuel ? styles.activeFilter : styles.filterBtn
              }
              onClick={() => setSelectedFuel(fuel)}
            >
              {fuel}
            </Button>
          ))}
        </div>
      )}

      <div className={`${styles.fuelSections}`} data-selected-fuel={selectedFuel}>
        {children}
      </div>
    </div>
  );
}; 